// @ts-check
import * as UnboundModalActions from './UnboundModalActions';
import { getStore } from 'shared/stash';

const hideModal = (...args) => getStore().dispatch(UnboundModalActions.hideModal(...args));
const showModal = (...args) => getStore().dispatch(UnboundModalActions.showModal(...args));

export { showModal, hideModal };
